module.exports = __webpack_public_path__ + "img/start_video.6d7933bf.png";